<template>
  <div class="m-swiper" :class="classMap[swiperType]">
    <swiper ref="mySwiper" :options="swiperOptions">
      <swiper-slide v-for="(item, index) in swiperLength" :key="index">
        <slot :name="`swiper-${index}`"></slot>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
      <div v-if="swiperType == 3" class="swiper-button-prev" slot="button-prev"></div>
      <div v-if="swiperType == 3" class="swiper-button-next" slot="button-next"></div>
    </swiper>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
  props: {
    swiperLength: {
      type: Number
    },
    swiperType: { // 1banner 2公益事业卡片 3合作案例
      type: Number,
      default: 1
    },
    isLoop: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      classMap: {
        1: 'm-full-swiper',
        2: 'm-full-swiper m-card-swiper',
        3: 'm-pre-swiper'
      },
      swiperList: [],
      swiperOptions:{
        //显示分页
        pagination: {
          el: this.swiperType == 3 ? '' : '.swiper-pagination'
        },
        //自动轮播
        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        },
        speed: 1000,
        //开启循环模式
        loop: this.isLoop,
        slidesPerView: this.swiperType == 3 ? "auto" : 1, // 默认1
        centeredSlides: this.swiperType == 3 ? true : false,  // 默认false
        spaceBetween: this.swiperType == 2 ? 1 : 0, // 默认0
        navigation: {
          nextEl: this.swiperType == 3 ? '.swiper-button-next' : '',
          prevEl: this.swiperType == 3 ? '.swiper-button-prev' : ''
        },
        on:{
          click: function(e){
            if (e.target.getAttribute('data-url')) {
              window.open(e.target.getAttribute('data-url'))
            }
          }
        }
      }
    }
  },
  methods: {
  },
  components: {
    Swiper,
    SwiperSlide
  }
}
</script>
<style lang="scss" scoped>
.m-swiper {
  .banner-img {
    width: 100%;
    height: 100%;
    // height: 568px;
    display: block;
  }
}
</style>
<style lang="scss">
.m-swiper {
  width: 100%;
  .swiper-container-horizontal>.swiper-scrollbar {
      width: 1.2rem;
      left: 50%;
      transform: translateX(-50%);
      background: #DDEEFF;
  }
  .swiper-scrollbar-drag {
    background: #217CFE;
  }
  .swiper-pagination-bullet {
    background: #DDEEFF;
    opacity: 1;
  }
  .swiper-pagination-bullet-active {
    background: #217CFE;
  }
}
.m-full-swiper {
  .swiper-container {
    width: 100%;
    img {
      width: 100%;
      display: block;
    }
  }
  .swiper-container-horizontal >.swiper-pagination-bullets {
    bottom: .14rem;
    font-size: .16rem;
  }
  .swiper-pagination-bullet {
    width: .53rem;
    height: .05rem;
    background: #FFFFFF;
    border-radius: 0%;
  }
  .swiper-pagination-bullet-active {
    background: #217CFE;
  }
}
.m-card-swiper {
  .swiper-container-horizontal >.swiper-pagination-bullets {
    bottom: 0;
  }
  .swiper-pagination-bullet {
    background: rgba(33, 124, 254, .2);
  }
  .swiper-pagination-bullet-active {
    background: #217CFE;
  }
}
.m-pre-swiper {
  .swiper-container {
    width: 100%;
    height:  3.54rem;
    overflow: hidden !important;
  }
  .swiper-container-horizontal >.swiper-pagination-bullets {
    bottom: -.2rem;
  }
  .swiper-container .swiper-wrapper .swiper-slide{ width: 4.76rem; border-radius: .02rem;}
  .swiper-container .swiper-wrapper .swiper-slide img{width: 100%; height: 3.54rem; border-radius: .02rem;}
  .swiper-container .swiper-wrapper .swiper-slide-prev{ height: 3.54rem !important;}
  .swiper-container .swiper-wrapper .swiper-slide-prev img{
    height: 2.72rem !important;
    margin-top: .6rem;
  }
  .swiper-container .swiper-wrapper .swiper-slide-next{ height: 3.54rem !important;}
  .swiper-container .swiper-wrapper .swiper-slide-next img{ 
    height: 2.72rem !important;
    margin-top: .6rem;
  }
  .swiper-container .swiper-wrapper .swiper-slide-active{ width: 4.76rem;}
  .swiper-container-horizontal>.swiper-scrollbar {
    bottom: -.4rem;
  }
  .swiper-button-prev, .swiper-button-next {
    width: .5rem;
    height: .5rem;
    border-radius: 50%;
    background: rgba(0,0,0,.3);
    top: 1.86rem;
  }
  .swiper-button-prev:after, .swiper-button-next:after {
    font-size: .28rem;
    font-weight: bold;
    color: #fff;
  }
  .swiper-button-prev {
    left: .32rem;
  }
  .swiper-button-next {
    right: .32rem;
  }
}
</style>